import ClaimClosedNotice from "./ClaimClosedNotice";

export default ClaimClosedNotice;
